import { render, staticRenderFns } from "./DashboardList.vue?vue&type=template&id=776b3402&scoped=true&"
import script from "./DashboardList.vue?vue&type=script&lang=js&"
export * from "./DashboardList.vue?vue&type=script&lang=js&"
import style0 from "./DashboardList.vue?vue&type=style&index=0&id=776b3402&scoped=true&lang=css&"
import style1 from "@/assets/styles/tooltips.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776b3402",
  null
  
)

export default component.exports